import { render, staticRenderFns } from "./SearchTextField.vue?vue&type=template&id=3ccafc16&scoped=true&"
import script from "./SearchTextField.vue?vue&type=script&lang=js&"
export * from "./SearchTextField.vue?vue&type=script&lang=js&"
import style0 from "./SearchTextField.vue?vue&type=style&index=0&id=3ccafc16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccafc16",
  null
  
)

export default component.exports